import React from "react";

const Facebook = ({ width = 30 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={width}>
    <path d="M36.86 49.82h-9.8V32.24h9.8V20.93c0-8.11 3.85-20.81 20.8-20.81h15.28v17H61.86c-1.81 0-4.37.9-4.37 4.77v10.3h15.72L71.4 49.82H57.49v49.61H36.86z" />
  </svg>
);

export default Facebook;
